<template>
  <div class="data-visualisation-tab dashboard-tab">
    <div class="row">
      <div class="col-md-6">
        <div class="chart-container">
          <vuestic-chart v-if="loaded" v-bind:data="donutChartData" type="donut"></vuestic-chart>
        </div>
      </div>
      <div class="col-md-6">
        <vuestic-data-table
          :apiMode="apiMode"
          :tableData="tableData"
          :tableFields="tableFields"
          :itemsPerPage="itemsPerPage"
          :onEachSide="onEachSide"
          :sortFunctions="sortFunctions"
          :dataModeFilterableFields="dataModeFilterableFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import BadgeColumn from 'components/tables/BadgeColumn.vue'
import TableData from './TableData'
import DonutChartData from './DonutChartData'
import FieldsDef from './fields-definition'
import urlApi from '../../../router/urlApi'
import store from 'vuex-store'

Vue.component('badge-column', BadgeColumn)

export default {
  name: 'data-visualisation-tab',

  data () {
    return {
      donutChartData: DonutChartData,
      apiMode: false,
      sortFunctions: FieldsDef.sortFunctions,
      tableData: TableData,
      onEachSide: 1,
      tableFields: FieldsDef.tableFields,
      dataModeFilterableFields: ['name'],
      itemsPerPage: [
        {
          value: 5
        },
        {
          value: 6
        }
      ],
      loaded: false
    }
  },

  beforeCreate () {
    let self = this
    this.$http.get(urlApi + '/alunos/etapas').then(function (response) {
      var dataChart = [...new Set(Object.values(response.data.dados))];
      if(dataChart.length == 1 && dataChart[0] == 0){
        DonutChartData.labels = ['Nenhum Aluno Cadastrado'];
        DonutChartData.datasets[0].data = [1];
      } else {
        DonutChartData.labels = Object.keys(response.data.dados)
        DonutChartData.datasets[0].data = Object.values(response.data.dados)
      }
      self.loaded = true
    })
  }
}
</script>

<style lang="scss" scoped>
  .chart-container {
    padding: 0 2rem;
    height: 24rem;
  }

</style>
